export default "__VITE_ASSET__DVTUvYQ4__"